module.exports = __webpack_public_path__ + "img/62e1c62c5fd2c17eb5d916780369edbd.3404f676.png";